import { render } from "./Day.vue?vue&type=template&id=0032a29a&ts=true"
import script from "./Day.vue?vue&type=script&lang=ts"
export * from "./Day.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__